
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_3bgfn_64bxr_5",
  "source": "awsui_source_3bgfn_64bxr_9"
};
  